import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

// collapse mobile navbar when an in-page link is clicked
if (typeof window !== "undefined") {
  // use a delegated listener so it works for dynamically rendered links
  document.addEventListener(
    "click",
    (e) => {
      const anchor = e.target.closest && e.target.closest('a[href*="#"]');
      if (!anchor) return;

      const navbarToggle = document.querySelector(".navbar-toggle, .navbar-toggler");
      const navbarCollapse = document.querySelector(".navbar-collapse");

      if (!navbarToggle) return;

      const toggleVisible = getComputedStyle(navbarToggle).display !== "none";
      const isOpen =
        navbarCollapse &&
        (navbarCollapse.classList.contains("in") || navbarCollapse.classList.contains("show"));

      if (toggleVisible && isOpen) {
        // trigger the toggle to collapse the menu (Bootstrap-compatible)
        navbarToggle.click();
      }
    },
    true
  );
}

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      {/* Language switch and optional sections (Features, Manifesto) intentionally omitted here */}
      <Header data={landingPageData.Header} />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery} />
      <About data={landingPageData.About} />
      <Testimonials data={landingPageData.Testimonials} />
      <Team data={landingPageData.Team} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
